
/*FILTER JS*/
$('.toggle').click(function(e) {
    e.preventDefault();

  let $this = $(this);

  if ($this.hasClass('show')) {
      $this.removeClass('show');
      $this.next().slideUp(350);
      $this.next().removeClass("toggleborderbottom");
       $($this).removeClass("toggleborder");
      $($this).children().children().removeClass("arrow-up");

      
  } else {
      $this.toggleClass('show');
      $this.next().slideToggle(350);
      $this.next().addClass("toggleborderbottom");
       $($this).addClass("toggleborder");
      $($this).children().children().addClass("arrow-up");
      
      
  }
});


/*END FILTER JS*/
// Mobile Only Slider
mobileOnlySlider(".mySlider", true, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
      mobileFirst: true,
      slidesToShow: 2.7,
      slidesToScroll: 2.7,
      dots: false,
      arrows: false,
      responsive: [
          {
              breakpoint: $breakpoint,
              settings: "unslick"
          }
      ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
          return;
      }
      if (!slider.hasClass("slick-initialized")) {
          return slider.slick(settings);
      }
  });
} // END Mobile Only Slider JS
if($(window).innerWidth() <= 751) {
console.log("mill");

$(document).ready(function(){
    // Target the element with the class 'example' and remove the colon
    $('.dropdown .dropdown__label div span').text(function(index, text) {
        console.log("mill");
      return text.replace(':', '');
    });
  });
}
